export const OPEN_FOR_INTERVIEW = 'Open for interview'
export const PHONE_SCREENING = 'Phone Screening'
export const INTERVIEW = 'Interview Scheduling'
export const ARCHIVE = 'Archive'
export const HOLD = 'Hold'
export const REJECT = 'Reject'
export const HIRE = 'Hire'
